// EmployeeEditor.jsx

import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Input,
  CardHeader,
  Table,
  Label,
  Button,
} from "reactstrap";
import Breadcrumbs from "../../../Components/Common/BreadCrumbs";
import Schedule1 from "./Schedule/ScheduleCompononent1";
import Schedule2 from "./Schedule/ScheduleComponent2";
import Schedule3 from "./Schedule/ScheduleComponent3";
import ModalReport from "./Modal/modal";
import Stepper from "react-stepper-horizontal";
import ReportButton from "./Button/Button";
import options from "./data/organizationimg";
import ShowLogo from "./ShowLogo";
import { useLocation,useParams } from "react-router-dom";
import SubHeadingServices from "../../../services/COOPServices/SubHeadingServices/SubHeadingServices";
import TableComponent from "./components/TableComponent";
import CustomSelect from "../../../Components/Common/CustomSelect/CustomSelect";
import ReportTypeServices from "../../../services/COOPServices/ReportTypeServies/ReportTypeServices";
import { useFormik } from "formik";
import CustomInput from "../../../Components/Common/CustomInput/CustomInput";
import MonthlyReportServices from "../../../services/COOPServices/MonthlyReportServices/MonthlyReportServices";

const ReportEditor = () => {
  const [reportStatus, setReportStatus] = useState("new report");
  const [activeStep, setActiveStep] = useState();
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);
  const [headings, setHeadings] = useState();
  console.log("🚀 ~ ReportEditor ~ headings:", headings);
  const [reportTypeOption, setReportTypeOption] = useState();
  const { id } = useParams();
  const location = useLocation();
  const status = location.state?.status;
  const formik = useFormik({
    initialValues: {
      name: "",
      reportTypeId: "",
      year: "",
      month: "",
      reportTxns: [
        // {
        //   reportSubTxnDtos: [
        //     {
        //       subHeadingId: 0,
        //       credit: 0,
        //       debit: 0,
        //     },
        //   ],
        // },
      ],
    },
    onSubmit: async (values) => {
      const formattedData = {
        ...values,
        reportTypeId: values.reportTypeId?.value,
        year: values.year?.value,
        month: values.month?.value,
      };
      try {
        const response = await MonthlyReportServices.create(formattedData);
      } catch (error) {
        console.log("🚀 ~ onSubmit:async ~ error:", error);
      }
    },
  });

  const fetchReportTypeOption = async () => {
    try {
      const response = await ReportTypeServices.getList({
        pageNumber: 1,
        pageSize: 100,
      });
      const temp = response?.data?.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setReportTypeOption(temp);
    } catch (error) {
      console.log("🚀 ~ fetchReportTypeOption ~ error:", error);
    }
  };
  useEffect(() => {
    fetchReportTypeOption();
    fetchheadings();
  }, []);

  // const location = useLocation();
  // const state = useLocation();
  // const status = state.state?.status;
  // console.log(status, "status");

  useEffect(() => {
    switch (status) {
      case "Initiated":
        setReportStatus("initiated");
        setActiveStep(2);
        break;
      case "Draft":
        setReportStatus("drafted");
        setActiveStep(1);
        break;
      case "Approved":
        setReportStatus("approved");
        setActiveStep(5);
        break;
      case "Submitted":
        setReportStatus("Submitted");
        setActiveStep(3);
        break;
      case "Acknowledged":
        setReportStatus("Acknowledged");
        setActiveStep(4);
        break;
      // Add more cases as needed
      default:
        setReportStatus("new report");
        setActiveStep(0);
        break;
    }

    // ... (Other useEffect logic)
  }, [id,status]);

  const handleSelectedOrganization = (selected) => {
    setSelectedOrganizations(selected);
  };

  const fetchheadings = async () => {
    try {
      const response = await SubHeadingServices.getDisplayList();
      // console.log("🚀 ~ fetchheadings ~ response:", response);
      // response.headingDisplayDtos.map((subHeadingGroups) => {
      //   subHeadingGroups.map((subHeadings)=>{
      //     subHeadings.map((subHeading)=>{
      //       formik.setFieldValue()
      //     })
      //   })
      // });
      setHeadings(response);
    } catch (error) {
      console.log("🚀 ~ fetchheadings ~ error:", error);
    }
  };

  const steps = [
    { title: "New report" },
    { title: "Drafted" },
    { title: "Initiated" },
    { title: "Submitted" },
    { title: "Acknowledged" },
    { title: "Approved" },
  ];

  const breadcrumbItems = [
    { title: "Reports", link: "/report" },
    { title: "Create New Report" },
  ];

  console.log("formik.values", formik.values);

  return (
    <React.Fragment>
      <form onSubmit={formik.handleSubmit}>
        <Container fluid>
          <div className="">
            <div className="page-content">
              <Row>
                <Col>
                  <Breadcrumbs items={breadcrumbItems} />
                  <Row style={{ paddingRight: "17px" }}>
                    <ReportButton
                      // status={status}
                      reportStatus={reportStatus}
                      setReportStatus={setReportStatus}
                      setActiveStep={setActiveStep}
                      selectedOrganizations={selectedOrganizations}
                      setSelectedOrganization={handleSelectedOrganization}
                    />
                  </Row>
                  <Row className="px-2">
                    <Col lg={6}>
                      <Row>
                        <Card className="mt-4">
                          <CardBody className="mt-2">
                            <h6 className="fw-bold">
                              Your submission no:: 800058228983
                            </h6>
                            <div className="card-width-full">
                              <div className="d-flex">
                                <div className="mt-2 me-3 col">
                                  <CustomInput
                                    required
                                    label={"Name"}
                                    handleBlur={formik.handleBlur}
                                    handleChange={formik.handleChange}
                                    id={"name"}
                                    name={"name"}
                                    placeholder={"Report Name"}
                                    touched={formik.touched.name}
                                    value={formik.values.name}
                                    error={formik.errors.name}
                                  />
                                </div>
                                <div className="mt-2 me-3 col">
                                  <CustomSelect
                                    id={`reportTypeId`}
                                    name={`reportTypeId`}
                                    label={"Report Type"}
                                    options={reportTypeOption}
                                    placeholder={"Select Report Type"}
                                    required={true}
                                    setFieldTouched={formik.setFieldTouched}
                                    setFieldValue={formik.setFieldValue}
                                    touched={
                                      formik.touched.reportTypeId &&
                                      formik.touched?.reportTypeId
                                    }
                                    value={formik.values.reportTypeId}
                                    errors={
                                      formik.errors.reportTypeId &&
                                      formik.errors?.reportTypeId.value
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="py-1">
                              <div className="d-flex">
                                <div className="mt-2 me-3 col">
                                  <CustomSelect
                                    id={`year`}
                                    name={`year`}
                                    label={"Select Year"}
                                    options={[
                                      {
                                        label: "2080",
                                        value: 2080,
                                      },
                                    ]}
                                    placeholder={"Select Year"}
                                    required={true}
                                    setFieldTouched={formik.setFieldTouched}
                                    setFieldValue={formik.setFieldValue}
                                    touched={
                                      formik.touched.year &&
                                      formik.touched?.year
                                    }
                                    value={formik.values.year}
                                    errors={
                                      formik.errors.year &&
                                      formik.errors?.year.value
                                    }
                                  />
                                </div>
                                <div className="mt-2 me-3 col">
                                  <CustomSelect
                                    id={`month`}
                                    name={`month`}
                                    label={"Select Month"}
                                    options={[
                                      {
                                        label: "Baisakh",
                                        value: 1,
                                      },
                                      {
                                        label: "Jestha",
                                        value: 2,
                                      },
                                      {
                                        label: "Asadh",
                                        value: 3,
                                      },
                                      {
                                        label: "Shrawan",
                                        value: 4,
                                      },
                                    ]}
                                    placeholder={"Select Month"}
                                    required={true}
                                    setFieldTouched={formik.setFieldTouched}
                                    setFieldValue={formik.setFieldValue}
                                    touched={
                                      formik.touched.month &&
                                      formik.touched?.month
                                    }
                                    value={formik.values.month}
                                    errors={
                                      formik.errors.month &&
                                      formik.errors?.month.value
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Row>
                    </Col>
                    <Col lg={6} className="px-4 mt-4">
                      <Card
                        style={{
                          width: "100%",
                          height: "223px",
                          paddingTop: "60px",
                        }}
                      >
                        <Stepper
                          steps={steps}
                          activeStep={activeStep}
                          className=" pt-5 fs-10 mx-auto "
                          activeColor="green"
                          completeColor="green"
                        />
                      </Card>
                    </Col>
                  </Row>

                  <Row className="px-2">
                    <Row>
                      <Card className="p-0">
                        <CardBody className="pt-1">
                          {headings?.headingDisplayDtos
                            ?.slice(1, 3)
                            .map((item, index) => {
                              return (
                                <TableComponent
                                  heading={item?.headingNepName}
                                  subHeadingGroups={item?.subHeadingGroups}
                                  index={index}
                                  formik={formik}
                                />
                              );
                            })}
                        </CardBody>
                      </Card>
                      {["submitted", "approved"].includes(reportStatus) && (
                        <Card>
                          <h6 className="mt-3">
                            <strong>Report submitted to</strong>
                          </h6>

                          <Row className="justify-content-start mt-2">
                            <Col lg={10}>
                              <Row>
                                {options.map((option, index) => (
                                  <Col key={index} className="text-center mb-3">
                                    <div
                                      className="position-relative image-container px-auto border rounded"
                                      style={{
                                        borderWidth: "3px",
                                        height: "100%",
                                      }}
                                    >
                                      <div className="form-check form-check-success mb-3">
                                        <Input
                                          className="form-check-input custom-rounded position-absolute end-0 top-0 mt-2 me-2"
                                          type="checkbox"
                                          id={`image${index + 1}`}
                                          checked={
                                            selectedOrganizations[index] ||
                                            false
                                          }
                                        />

                                        <Label
                                          className="form-check-label"
                                          htmlFor={`image${index + 1}`}
                                        />
                                      </div>
                                      <div className="img-container mt-2">
                                        {option.image && (
                                          <img
                                            src={option.image}
                                            className="img-fluid rounded"
                                            alt={`Option ${index + 1}`}
                                            style={{
                                              width: "50%",
                                              height: "auto",
                                              margin: "auto",
                                            }}
                                          />
                                        )}
                                        <div className="text-below-image mt-2 px-2">
                                          <p>
                                            {index === 0
                                              ? "COPO MIS"
                                              : option.label}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </Col>
                                ))}
                              </Row>
                            </Col>
                          </Row>
                        </Card>
                      )}
                    </Row>
                  </Row>
                </Col>
              </Row>

              <Row style={{ paddingRight: "17px" }} className="mb-4">
                {/* <Button
                  size="lg"
                  className="ms-auto p-2 border-white"
                  color="danger"
                  style={{ width: "30%" }}
                >
                  Save as Draft
                </Button> */}

                <ReportButton
                  formik={formik}
                  reportStatus={reportStatus}
                  setReportStatus={setReportStatus}
                  setActiveStep={setActiveStep}
                  selectedOrganizations={selectedOrganizations}
                  setSelectedOrganization={handleSelectedOrganization}
                />
              </Row>

              <ModalReport />
            </div>
          </div>
        </Container>
      </form>
    </React.Fragment>
  );
};

export default ReportEditor;
